module.exports = __webpack_public_path__ + "static/img/home1.35dc7af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home1.svg
// module id = 3/n1
// module chunks = 1